import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldHalved, faHandshake, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { BryButton } from '../../components/UI/BryUI';
import logo from '../../logo.png';

export const LandingHero = ({ onGetStarted, onLearnMore, installable, onInstallPwa }) => {
  return (
    <section className="bry-landing-hero py-5 text-center text-md-start" style={{ backgroundColor: 'var(--bry-bg-primary, #F4F5F7)' }}>
      <div className="container">
        <div className="row align-items-center g-4">
          <div className="col-12 col-md-7">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <span className="badge rounded-pill mb-3 px-3 py-2" style={{ backgroundColor: 'rgba(14, 171, 176, 0.12)', color: 'var(--bry-accent, #0EABB0)', border: '1px solid var(--bry-accent, #0EABB0)', fontWeight: 600 }}>
                Transporte & Delivery rápido en El Tigre
              </span>
              
              <h1 className="display-4 fw-extrabold text-dark mb-3" style={{ lineHeight: 1.15, letterSpacing: '-0.02em' }}>
                Tu ciudad, tu ruta. <br />
                <span style={{ color: 'var(--bry-accent, #0EABB0)' }}>Movilidad eficiente y segura.</span>
              </h1>
              
              <p className="lead text-secondary mb-4" style={{ fontSize: '1.1rem', maxWidth: '540px' }}>
                Solicita transporte o encomiendas al instante con conductores verificados y la tarifa más justa de la zona.
              </p>

              <div className="d-flex flex-wrap gap-3 justify-content-center justify-content-md-start mb-4">
                <BryButton
                  variant="primary"
                  size="lg"
                  onClick={onGetStarted}
                  style={{ backgroundColor: 'var(--bry-accent, #0EABB0)', color: '#ffffff', border: 'none', fontWeight: 700 }}
                >
                  Comenzar ahora <FontAwesomeIcon icon={faChevronRight} className="ms-2" />
                </BryButton>

                <BryButton
                  variant="secondary"
                  size="lg"
                  onClick={onLearnMore}
                  style={{ borderColor: 'var(--bry-accent, #0EABB0)', color: 'var(--bry-accent, #0EABB0)', fontWeight: 600 }}
                >
                  Saber más
                </BryButton>
              </div>

              {/* Badges de confianza */}
              <div className="d-flex flex-wrap gap-4 pt-2 border-top border-secondary border-opacity-25">
                <div className="d-flex align-items-center gap-2">
                  <FontAwesomeIcon icon={faShieldHalved} style={{ color: 'var(--bry-accent, #0EABB0)' }} />
                  <span className="text-secondary small">Rastreo GPS 24/7</span>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <img src={logo} alt="Logo Bryemma" style={{ height: '18px', width: 'auto' }} />
                  <span className="text-secondary small">Conductores Verificados</span>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <FontAwesomeIcon icon={faHandshake} style={{ color: 'var(--bry-accent, #0EABB0)' }} />
                  <span className="text-secondary small">Tarifa Transparente</span>
                </div>
              </div>
            </motion.div>
          </div>

          <div className="col-12 col-md-5 text-center">
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="position-relative d-inline-block"
            >
              <div
                className="rounded-circle position-absolute top-50 start-50 translate-middle"
                style={{
                  width: '280px',
                  height: '280px',
                  background: 'radial-gradient(circle, rgba(14, 171, 176, 0.15) 0%, rgba(14, 171, 176, 0) 70%)',
                  filter: 'blur(30px)',
                  zIndex: 0
                }}
              />
              <div className="p-4 rounded-4 shadow position-relative" style={{ backgroundColor: 'var(--bry-bg-primary, #F4F5F7)', border: '1px solid var(--bry-accent, #0EABB0)', zIndex: 1 }}>
                <img src={logo} alt="Bryemma Logo Oficial" className="mb-3 d-block mx-auto" style={{ height: '80px', width: 'auto' }} />
                <h4 className="text-dark fw-bold mb-2">Bryemma App</h4>
                <p className="text-secondary small mb-3">La plataforma #1 de movilidad para El Tigre, Anzoátegui</p>
                {installable ? (
                  <button
                    onClick={onInstallPwa}
                    className="w-100 border-0 d-flex align-items-center justify-content-center gap-2"
                    style={{
                      backgroundColor: 'var(--bry-accent, #0EABB0)',
                      color: '#ffffff',
                      borderRadius: '8px',
                      padding: '10px 16px',
                      fontSize: '0.9rem',
                      fontWeight: 700,
                      cursor: 'pointer',
                      transition: 'opacity 0.2s',
                    }}
                    onMouseEnter={e => e.currentTarget.style.opacity = '0.85'}
                    onMouseLeave={e => e.currentTarget.style.opacity = '1'}
                  >
                    Instalar App — Disponible en PWA Web
                  </button>
                ) : (
                  <div className="badge px-3 py-2 w-100" style={{ backgroundColor: 'var(--bry-accent, #0EABB0)', color: '#ffffff', fontSize: '0.9rem' }}>
                    Disponible en PWA Web
                  </div>
                )}
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingHero;
